import React, { Component } from 'react';
import { Box, Container, Grid, IconButton, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { ArrowCircleLeftOutlined, ArrowCircleRightOutlined } from '@mui/icons-material';
import { SIDES } from './EquipementDetails';
import { extension } from 'mime-types';
import RemisePreview from '../Contract/RemisePreview';

class LoanSingle extends Component {
    state = {  }
    render() {
        const {loan, user, EQUIP} = this.props;
        return (
            <Container maxWidth="lg">
                {/* <RemisePreview
                    loan={loan}
                    user={user}
                    EQUIP={EQUIP}
                />  NOT WORKING HERE*/}
                {loan && 
                // <>
                //     <Typography variant="button" color="primary">Emprunt du {new Date(loan.loan_start_date).toLocaleDateString("fr-FR")}</Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Box p={1} style={{textAlign: "center"}}>
                                <Typography variant="h6">Emprunt du <b>{new Date(loan.loan_start_date).toLocaleDateString("fr-FR")}</b> par <b>{`${user.username} ${user.lastname}` }</b></Typography>
                            </Box>
                        </Grid>

                        <Grid item container sm={6} xs={12}>
                            <Grid item xs={12}>
                                <Box p={1} style={{textAlign: "center"}}><Typography variant="button" color="primary"><b>Etat Départ</b></Typography></Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box p={1}>Date: {new Date(loan.loan_start_date).toLocaleDateString("fr-FR")}</Box>
                                <Box p={1}>Date de retour prévue: {new Date(loan.loan_estimated_return).toLocaleDateString("fr-FR")}</Box>
                                <Box p={1}>Etat: {loan.equipement_state_start}</Box>
                                <Box p={1}>Remarques: {loan.equipement_remarks_start}</Box>
                                {loan.loan_vehicule && <Box p={1}>Km: {loan.loan_km_start}</Box>}
                                {loan.loan_vehicule && <Box p={1}>Carburant: {loan.loan_fuel_start}</Box>}
                            </Grid>
                            {SIDES.map( side =>
                                <Grid item xs={6}>
                                    <a href={`/photos/single/${loan[`loan_photo_${side.name}_start`].filename}`} 
                                        download={`${side.name}.${ extension(loan[`loan_photo_${side.name}_start`].filetype) || "jpeg"}`}
                                    >
                                        <img 
                                            // style={{opacity: ".7"}}
                                            src={`/photos/single/${loan[`loan_photo_${side.name}_start`].filename}`} 
                                            title={side.name} 
                                            alt={side.name} 
                                        />
                                    </a>
                                </Grid>
                            )}                                
                        </Grid>
                        
                        <Grid item container sm={6} xs={12} style={{borderLeft:"1px solid lightgray"}}>
                            <Grid item xs={12}>
                                <Box p={1} style={{textAlign: "center"}}><Typography variant="button" color="primary"><b>Etat Retour</b></Typography></Box>
                            </Grid>
                            {loan.is_over && 
                            <>
                                <Grid item xs={12}>
                                    <Box p={1}>Date: {new Date(loan.loan_end_date).toLocaleDateString("fr-FR")}</Box>
                                    <Box p={1}>-</Box>
                                    <Box p={1}>Etat: {loan.equipement_state_end}</Box>
                                    <Box p={1}>Remarques: {loan.equipement_remarks_end}</Box>
                                    {loan.loan_vehicule && <Box p={1}>Km: {loan.loan_km_end}</Box>}
                                    {loan.loan_vehicule && <Box p={1}>Carburant: {loan.loan_fuel_end}</Box>}
                                </Grid>
                                {SIDES.map( side =>
                                    <Grid item xs={6}>
                                        <a href={`/photos/single/${loan[`loan_photo_${side.name}_end`].filename}`} 
                                            download={`${side.name}.${ extension(loan[`loan_photo_${side.name}_end`].filetype) || "jpeg"}`}
                                        >
                                            <img 
                                                // style={{opacity: ".7"}}
                                                src={`/photos/single/${loan[`loan_photo_${side.name}_end`].filename}`} 
                                                title={side.name} 
                                                alt={side.name} 
                                            />
                                        </a>
                                    </Grid>
                                )}    
                            </>                        
                            }
                        </Grid>
                    </Grid> 
                // </>
                }   
            </Container>
        );
    }
}

export default LoanSingle;